<div *ngIf="updateAvailable$ | async">
  <span translate>GLOBAL.UPDATE_TOAST.UPDATE_AVAILABLE</span>
  <span class="link" (click)="update()" translate>GLOBAL.UPDATE_TOAST.UPDATE_NOW</span>
</div>
